import React, { Component, PropTypes } from 'react';
import CSSPropertyOperations from 'react/lib/CSSPropertyOperations';
import shallowEqual from 'shallowequal';
import ReactDOM, {
  unmountComponentAtNode,
  unstable_renderSubtreeIntoContainer
} from 'react-dom';

const isDescendant = (parent, child) => {
  let node = child.parentNode;
  while (node !== null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};

export default class Portal extends Component {
  static displayName = 'Portal';

  static propTypes = {
    style: PropTypes.object,
    onClickAway: PropTypes.func,
    onMount: PropTypes.func
  };

  componentWillMount() {
    const { onMount, onClickAway } = this.props;
    this.node = document.createElement('div');
    CSSPropertyOperations.setValueForStyles(this.node, this.props.style);
    document.body.appendChild(this.node);
    this.renderPortal(this.props);
    onMount && onMount(this.node);
    if (onClickAway) {
      document.body.addEventListener('mousedown', this.handleClickAway);
      document.body.addEventListener('touchstart', this.handleClickAway);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.renderPortal(nextProps);
  }

  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps);
  }

  componentWillUnmount() {
    const { onClickAway } = this.props;
    this.closePortal();
    if (onClickAway) {
      document.body.removeEventListener('mousedown', this.handleClickAway);
      document.body.removeEventListener('touchstart', this.handleClickAway);
    }
  }

  node = null;

  handleClickAway = event => {
    const { onClickAway } = this.props;
    if (!isDescendant(this.node, event.target)) {
      onClickAway();
    }
  };

  closePortal() {
    if (this.node) {
      unmountComponentAtNode(this.node);
      document.body.removeChild(this.node);
    }
    this.node = null;
  }

  renderPortal(props) {
    const { children, style, className, ...other } = props;
    CSSPropertyOperations.setValueForStyles(this.node, style);
    if (className) {
      this.node.className = className;
    }
    if (children && children.length > 0) {
      ReactDOM.unstable_renderSubtreeIntoContainer(
        this,
        <div {...other}>{children}</div>,
        this.node
      );
    } else if (children) {
      ReactDOM.unstable_renderSubtreeIntoContainer(
        this,
        React.Children.only(children),
        this.node
      );
    }
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/js/Cio/Portal.js